import { HttpStatusCode } from 'axios';
import { NotificationService } from 'services/notification-service';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

export const initThrottleInterceptor = () => {
  axiosBaseInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === HttpStatusCode.TooManyRequests) {
        NotificationService.showResult(false, 'APP.TOO_MANY_REQUEST_ERROR');
      }
      return Promise.reject(error);
    }
  );
};
